module.exports = __webpack_public_path__ + "img/dz_down_logo.eca4b0f2.png";